import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import br from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "./datePickerDashboard.css";
registerLocale("pt-BR", br);

export default class InputReportTime extends React.Component {

  state = {
    text: new Date(),
  };

  changeValue = (value) => {
    this.setState({ text: value }, () => {
      const val = moment(value).format("DD/MM/YYYY").toString();
      this.props.parentCallback(val);
    });
  };

  render() {
    return (          
      <div className="insideContainer">
        <label className="reportLabel">
            <strong>{this.props.title}:</strong>{" "}
          </label>
        <DatePicker
          className={"dpd-inside " + this.props.className}
          name={this.props.name}
          selected={this.state.text}
          onChange={(e) => this.changeValue(e)}
          closeOnScroll={true}
          autoComplete="off"
          dateFormat="dd/MM/yyyy"
          locale="pt-BR"
        />
      </div>
    );
  }
}